import GenericListView from 'src/components/generic-crud/GenericListView';
import { endpoints } from 'src/utils/axios';
import { paths } from 'src/routes/paths';
import { featureConfig } from './featureConfig';

export default function FeatureMasterListView() {
    return (
        <GenericListView
            config={featureConfig}
            breadcrumbs={{
                heading: 'Feature Master',
                links: [
                    { name: 'Dashboard', href: paths.dashboard.root },
                    { name: 'Feature Master' },
                ],
            }}
            endpoints={{
                list: endpoints.featureMaster.list,
                create: endpoints.featureMaster.create,
                update: endpoints.featureMaster.update,
            }}
            apiEndpoints={endpoints.featureMaster}
        />
    );
}
